import React, {Component} from 'react';
import CommunityNotice from './CommunityNotice';
import timeSince from '../timeSince';
import {Avatar} from '../widgets';
import {fetchJson, postJson} from '../fetchJson';

import './MinimalCommunityNotice.css';

/**
 * Community notice component that lazily loads the comments. Used in the
 * activity stream page.
 */
class MinimalCommunityNotice extends CommunityNotice {
	constructor(props) {
		super(props);
		this.state = {
			expanded: false,
			commentsShown: false,
			newComment: '',
			comments: []
		};

		this.loadComments = (noticeUuid, communityUuid) => {
			// loads comments for this notice into local component state
			fetchJson(`/api/community/${communityUuid}/notices/${noticeUuid}/comments`).then(comments =>
				this.setState({commentsShown: true, comments})
			);
		};
		this.addComment = (uuid, poster, newComment, communityUuid) => {
			if (newComment !== '') {
				postJson(`/api/community/${communityUuid}/notices/${uuid}/comment`, {
					content: newComment
				}).then(res =>
					this.setState(prevState => ({
						comments: [...prevState.comments, {...poster, content: newComment}],
						newComment: ''
					}))
				);
			}
		};
	}

	render() {
		const {
			uuid,
			title,
			content,
			backgroundURL,
			userUuid,
			sessionProvider,
			createdAt,
			poster,
			community
		} = this.props;
		const {expanded, commentsShown, comments} = this.state;

		const isLarge = content && content.length > 256;
		const contentObj = content && this.linkify(content);

		const bgImg = this.UUIDRegex.test(backgroundURL)
			? `/api/image/${backgroundURL}`
			: backgroundURL;

		return (
			<article className="MinimalCommunityNotice">
				<header style={{backgroundImage: `url(${bgImg})`}}>
					<div>
						<h2 style={this.calcTitleSize(title)}>{title}</h2>
						<div className="MinimalCommunityNotice-time">
							{createdAt ? timeSince(new Date(Date.parse(createdAt))) : 'Just now'}
						</div>
						<Avatar className="MinimalCommunityNotice-avatar" provider={poster} size={32} />
					</div>
				</header>

				<div
					className={`MinimalCommunityNotice-description ${
						isLarge ? (expanded ? 'expanded' : '') : 'small'
					}`}>
					{contentObj &&
						contentObj.map(part =>
							part.type === 'link' ? (
								<a
									href={part.content[0] === 'h' ? part.content : 'http://' + part.content}
									target="_blank"
									rel="noopener noreferrer">
									{part.content}
								</a>
							) : (
								<span>{part.content}</span>
							)
						)}
					<button onClick={this.toggleExpansion}>
						<span className="MinimalCommunityNotice-icon-expand_more icon" />
						{isLarge && <span>{expanded ? 'Read less' : 'Read more'}</span>}
					</button>
				</div>

				{/* COMMENTS SECTION */}
				{commentsShown ? (
					<div className="MinimalCommunityNotice-conversation">
						<ol className="MinimalCommunityNotice-messages">
							{comments &&
								comments.map(({userUuid, content, firstname, avatarImage, uniqueName}) => {
									return (
										<li key={`${userUuid}_${content}`}>
											<Avatar
												provider={{user: {firstname}, profile: {uniqueName, avatarImage}}}
												size={32}
											/>
											<div className="MinimalCommunityNotice-content">{content}</div>
										</li>
									);
								})}
						</ol>

						<div className="MinimalCommunityNotice-edit">
							<div className="MinimalCommunityNotice-avatar me" />
							<Avatar provider={sessionProvider.provider} size={32} />
							<input
								type="text"
								onChange={this.changeNewComment}
								// disable this for now as it's causing an error with the new addComment
								// onKeyPress={this.newCommentKeyPress}
								value={this.state.newComment}
							/>
							<button
								onClick={() => {
									this.addComment(
										uuid,
										{
											userUuid,
											firstname: sessionProvider.user.firstname,
											...sessionProvider.provider.profile
										},
										this.state.newComment,
										community.uuid
									);
								}}>
								<span className="icon icon-send" />
							</button>
						</div>
						<div className="MinimalCommunityNotice-hideComments">
							<button onClick={() => this.setState({commentsShown: false})}>Hide Comments</button>
						</div>
					</div>
				) : (
					<div className="MinimalCommunityNotice-showComments">
						<button onClick={() => this.loadComments(uuid, community.uuid)}>Show Comments</button>
					</div>
				)}
			</article>
		);
	}
}

export default MinimalCommunityNotice;



// WEBPACK FOOTER //
// ./src/community/MinimalCommunityNotice.js